import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function VacationPriceFilter({ minPrice = '', maxPrice = '', onApply }) {
  const { t } = useTranslation();
  const root = useRef(null);
  const trigger = useRef(null);
  const [open, setOpen] = useState(false);
  const [minimum, setMinimum] = useState(minPrice);
  const [maximum, setMaximum] = useState(maxPrice);
  const [error, setError] = useState(false);
  useEffect(() => { setMinimum(minPrice); setMaximum(maxPrice); setError(false); }, [minPrice, maxPrice]);
  useEffect(() => {
    if (!open) return;
    const close = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);
  const label = minPrice !== '' && maxPrice !== '' ? `${minPrice} - ${maxPrice} TND`
    : minPrice !== '' ? `${t('vacationPrice.from')} ${minPrice} TND`
    : maxPrice !== '' ? `${t('vacationPrice.until')} ${maxPrice} TND` : t('vacationPrice.price');
  const apply = () => {
    if ([minimum, maximum].some(value => value !== '' && (!Number.isFinite(Number(value)) || Number(value) < 0)) ||
        (minimum !== '' && maximum !== '' && Number(minimum) > Number(maximum))) {
      setError(true); return;
    }
    onApply(minimum, maximum); setOpen(false); trigger.current?.focus();
  };
  return <div ref={root} className="relative min-w-0" onKeyDown={event => {
    if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    if (open && event.key === 'Enter' && event.target.tagName === 'INPUT') { event.preventDefault(); apply(); }
  }}>
    <button ref={trigger} type="button" aria-expanded={open} aria-controls="vacation-price-popover"
      onClick={() => { setMinimum(minPrice); setMaximum(maxPrice); setError(false); setOpen(!open); }}
      className="min-h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700">
      {label}
    </button>
    {open && <div id="vacation-price-popover" role="dialog" aria-label={t('vacationPrice.price')}
      className="absolute start-0 top-full z-30 mt-2 w-72 max-w-full rounded-2xl border border-slate-200 bg-white p-4 text-start shadow-xl">
      <label className="block text-sm font-bold" htmlFor="vacation-min-price">{t('vacationPrice.minimum')}</label>
      <input autoFocus id="vacation-min-price" type="number" min="0" step="any" dir="ltr" inputMode="decimal"
        value={minimum} onChange={event => { setMinimum(event.target.value); setError(false); }}
        className="mb-3 mt-1 w-full min-w-0 rounded-xl border p-2" />
      <label className="block text-sm font-bold" htmlFor="vacation-max-price">{t('vacationPrice.maximum')}</label>
      <input id="vacation-max-price" type="number" min="0" step="any" dir="ltr" inputMode="decimal"
        value={maximum} onChange={event => { setMaximum(event.target.value); setError(false); }}
        className="mb-2 mt-1 w-full min-w-0 rounded-xl border p-2" />
      <p className="text-sm text-slate-500">{t('vacationPrice.unit')}</p>
      {error && <p role="alert" className="mt-2 text-sm text-red-600">{t('vacationPrice.invalid')}</p>}
      <button type="button" onClick={apply} className="mt-3 w-full rounded-xl bg-green-600 p-2 font-bold text-white">{t('vacationPrice.apply')}</button>
    </div>}
  </div>;
}
